import {
  STATUS_DASHBOARD_INGESTS_LOADING,
  STATUS_DASHBOARD_INGESTS_SUCCESS,
  STATUS_DASHBOARD_INGESTS_ERROR,
  STATUS_DASHBOARD_TRANSFERS_LOADING,
  STATUS_DASHBOARD_TRANSFERS_SUCCESS,
  STATUS_DASHBOARD_TRANSFERS_ERROR,
  STATUS_DASHBOARD_PROXIES_LOADING,
  STATUS_DASHBOARD_PROXIES_SUCCESS,
  STATUS_DASHBOARD_PROXIES_ERROR,
  STATUS_DASHBOARD_FAILED_ACTIONS_LOADING,
  STATUS_DASHBOARD_FAILED_ACTIONS_SUCCESS,
  STATUS_DASHBOARD_FAILED_ACTIONS_ERROR,
  STATUS_DASHBOARD_WORK_ORDERS_LOADING,
  STATUS_DASHBOARD_WORK_ORDERS_SUCCESS,
  STATUS_DASHBOARD_WORK_ORDERS_ERROR
} from './constants';

const initialState = {
  ingests: {data: [], loading: false, error: null},
  transfers: {data: [], loading: false, error: null},
  proxies: {data: [], loading: false, error: null},
  failedActions: {data: [], loading: false, error: null},
  workOrders: {data: [], loading: false, error: null}
};

export default function statusDashboardReducer(state = initialState, action) {
  switch (action.type) {
    // Ingests
    case STATUS_DASHBOARD_INGESTS_LOADING:
      return {...state, ingests: {...state.ingests, loading: true, error: null}};
    case STATUS_DASHBOARD_INGESTS_SUCCESS:
      return {...state, ingests: {data: action.data, loading: false, error: null}};
    case STATUS_DASHBOARD_INGESTS_ERROR:
      return {...state, ingests: {...state.ingests, loading: false, error: action.error}};

    // Transfers
    case STATUS_DASHBOARD_TRANSFERS_LOADING:
      return {...state, transfers: {...state.transfers, loading: true, error: null}};
    case STATUS_DASHBOARD_TRANSFERS_SUCCESS:
      return {...state, transfers: {data: action.data, loading: false, error: null}};
    case STATUS_DASHBOARD_TRANSFERS_ERROR:
      return {...state, transfers: {...state.transfers, loading: false, error: action.error}};

    // Proxies
    case STATUS_DASHBOARD_PROXIES_LOADING:
      return {...state, proxies: {...state.proxies, loading: true, error: null}};
    case STATUS_DASHBOARD_PROXIES_SUCCESS:
      return {...state, proxies: {data: action.data, loading: false, error: null}};
    case STATUS_DASHBOARD_PROXIES_ERROR:
      return {...state, proxies: {...state.proxies, loading: false, error: action.error}};

    // Failed Actions
    case STATUS_DASHBOARD_FAILED_ACTIONS_LOADING:
      return {...state, failedActions: {...state.failedActions, loading: true, error: null}};
    case STATUS_DASHBOARD_FAILED_ACTIONS_SUCCESS:
      return {...state, failedActions: {data: action.data, loading: false, error: null}};
    case STATUS_DASHBOARD_FAILED_ACTIONS_ERROR:
      return {...state, failedActions: {...state.failedActions, loading: false, error: action.error}};

    // Work Orders
    case STATUS_DASHBOARD_WORK_ORDERS_LOADING:
      return {...state, workOrders: {...state.workOrders, loading: true, error: null}};
    case STATUS_DASHBOARD_WORK_ORDERS_SUCCESS:
      return {...state, workOrders: {data: action.data, loading: false, error: null}};
    case STATUS_DASHBOARD_WORK_ORDERS_ERROR:
      return {...state, workOrders: {...state.workOrders, loading: false, error: action.error}};

    default:
      return state;
  }
}
